/** @format */

import { post } from '@root/utils/httpWrap';
// eslint-disable-next-line no-unused-vars
import { IQueryRuleListParam, IUpdateRuleStatusParam } from './type';
// import { setHttp } from '@root/utils/http'

// const http = setHttp({}, 'v2')

/**
 * 计费规则列表查询
 */
export const loadAllRulesList = (params: IQueryRuleListParam): any => {
  return post('/bangdao/saasapi/v1/chargeRule/loadAllRules', params);
};
/**
 * 计费规则失效生效状态更新
 */
export const updateStatus = (params: IUpdateRuleStatusParam): any => {
  return post('/bangdao/saasapi/v1/chargeRule/updateStatus', params);
};

/**
 * 计费规则详情查询,
 */
export const getRuleDetailById = (params: { id: string }): any => {
  return post(`/bangdao/saasapi/v1/chargeRule/getById`, params);
};
/**
 * 计费规则新增
 */
export const addRule = (params: IUpdateRuleStatusParam): any => {
  return post('/bangdao/saasapi/v1/chargeRule/addRule', params);
};

/**
 * 统一业务管理-通行规则设置-获取详情
 * @url '/baseUniformRule/detail'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getPassRuleDetailAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseUniformRule/detail', params);
};

/**
 * 统一业务管理-通行规则设置-保存
 * @url '/baseUniformRule/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const editPassRuleAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseUniformRule/edit', params);
};

/**
 * 统一业务管理-电子发票设置-获取列表
 * @url '/invoice/list'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getInvoiceListAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/invoice/list', params);
};

/**
 * 统一业务管理-电子发票设置-获取全部列表 用于下拉
 * @url '/invoice/getInvoices'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getInvoiceAllListAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/invoice/findInvoiceByOrganId', params);
};

/**
 * 统一业务管理-电子发票设置-获取编辑详情
 * @url '/invoice/editInfo'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getInvoiceEditInfoAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/invoice/detail', params);
};

/**
 * 统一业务管理-电子发票设置-新增
 * @url '/invoice/add'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const createInvoiceAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/invoice/add`, params);
};

/**
 * 统一业务管理-电子发票设置-修改
 * @url '/invoice/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const updateInvoiceAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/invoice/edit`, params);
};

/**
 * 统一业务管理-电子发票设置-删除
 * @url '/invoice/del'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const deleteInvoiceAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/invoice/del`, params);
};

/**
 * 统一业务管理-电子发票设置-电子发票绑定车场
 * @url '/invoice/relationPark'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const invoiceRelationParkAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/invoice/relationPark`, params);
};

/**
 * 统一业务管理-电子发票设置-车场获取发票企业信息
 * @url '/invoice/del'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getParkInvoiceDetailAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/invoice/findInvoiceByParkId`, params);
};

/**
 * 统一业务管理-线上业务设置-获取详情
 * @url '/baseParkService/detail'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getParkServiceDetailAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/baseParkService/detail`, params);
};

/**
 * 统一业务管理-线上业务设置-保存
 * @url '/baseParkService/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const editParkServiceAPI = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/baseParkService/edit`, params);
};

/**
 * 统一业务管理-支付通道设置-查询支付平台
 * @url '/baseParkService/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getPayPlatList = (params: { parkId: string }): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/payPlatForm/list`, params);
};

/**
 * 统一业务管理-支付通道设置-查询
 * @url '/baseParkService/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const getPayRuleInfo = (params: { parkId: string }): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/payPlatForm/info?parkId=${params.parkId}`, params);
};

/**
 * 统一业务管理-支付通道设置-保存
 * @url '/baseParkService/edit'
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
export const editPayRule = (params: {
  parkId: string;
  editPayPlatFormPlateList: any;
}): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/payPlatForm/edit`, params);
};

/**
 * 统一业务管理-自主业务设置-逾期短信提醒
 * @method POST
 * @header Authorization: 登录接口返回的token
 * @param params
 * @returns {*}
 */
interface smsNoticeType {
  parkId: string; // 车场ID
  enabled: string; // 状态，00禁用，01启用
  days: string; // 提前提醒天数，多个天数以逗号隔开
  smsId: string; // 短信模板Id
  carType: string; // 月卡类型
  id?: string; // 传ID则表示更新
}
export const postSmsNotice = (contents: smsNoticeType[]) => {
  return post(`/bangdao/saasapi/v1/helpself/smsNotice/addOrEdit`, { contents }).catch(e => {
    return {
      status: e.status,
      msg: e.msg ? e.msg : e.data && e.data.message
    };
  });
};

/**
 * 统一业务管理-自主业务设置-获取短信模板内容
 * @method POST
 * @returns {*}
 */
export const getSmsTemplateCon = (): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/helpself/tentcentSms/getSmsTemplate`);
  // return new Promise<any>(resolve => {
  //   setTimeout(() => {
  //     resolve({
  //       code: '200',
  //       status: '9999',
  //       msg: 'xxx',
  //       data: [
  //         {
  //           pkSms: '1',
  //           content: '万达国庆限时优惠套餐万达国庆限时优惠套餐',
  //         },
  //         {
  //           pkSms: '2',
  //           content: '万达国庆限时优惠套餐万达国庆限时优惠套餐2',
  //         },
  //       ],
  //     })
  //   }, 1000)
  // })
};

/**
 * 统一业务管理-自主业务设置-获取长租/产权短信配置
 * @method POST
 * @param parkId // 车场ID
 * @returns {*}
 */
export const getSmsTemplateConfig = (parkId: string): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/helpself/smsNotice/getConfigureByParkId`, { parkId });
  // return new Promise<any>(resolve => {
  //   setTimeout(() => {
  //     resolve({
  //       code: '200',
  //       status: '9999',
  //       msg: 'xxx',
  //       data: [
  //         {
  //           pkSmsNotice: '1',
  //           carType: '01',
  //           smsId: '1',
  //           advanceDay: '1,2',
  //           enabled: '01',
  //         },
  //         {
  //           pkSmsNotice: '2',
  //           carType: '02',
  //           advanceDay: '',
  //           enabled: '00',
  //         },
  //       ],
  //     })
  //   }, 1000)
  // })
};
